import React from "react";

const TextInput = React.forwardRef(({ mono = false, invalid = false, valid = false, className = "", ...props }, ref) => (
  <input
    ref={ref}
    className={[
      "w-full h-11 border-[1.5px] rounded-[var(--r-sm)] px-3 bg-[var(--panel)] text-[var(--ink)] text-[15px] font-body",
      "outline-none transition-[border-color,box-shadow] focus:border-[var(--accent)] focus:shadow-[0_0_0_3px_color-mix(in_srgb,var(--accent)_10%,transparent)]",
      mono ? "font-mono tracking-[.04em]" : "",
      invalid ? "border-[var(--danger)]" : valid ? "border-[var(--ok)]" : "border-[var(--line-2)]",
      props.readOnly ? "bg-[var(--panel-2)] text-[var(--muted)]" : "",
      className,
    ].join(" ")}
    {...props}
  />
));

export default TextInput;
